// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1WZP_","footer":"ModalInfo_footer__3RCxx"};